export default function classes(...args: string[]):string {
    let cnames = '';
    for (let i = 0; i < args.length; i++) {
        cnames = cnames + ' ' + args[i];
    }
    return cnames;
}
